import { Button, ButtonProps } from '@material-ui/core'
import React from 'react'
import AIIcon from 'resources/AIIcon'

const AI_DISCLAIMER_ICON_COLOR = '#8A30BE'

const AIDisclaimerIcon = ({ className, ...props }: ButtonProps) => (
    <Button aria-label="AI Disclaimer" className={className} {...props}>
        <AIIcon
            className="aiDisclaimerIcon"
            style={{ color: AI_DISCLAIMER_ICON_COLOR }}
        />
    </Button>
)

export default AIDisclaimerIcon
